function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { stringify, parse } from './jsurl';
import { decode, encode } from './qss';
export function stringifySearch(search) {
  search = _extends({}, search);

  if (search) {
    Object.keys(search).forEach(function (key) {
      var val = search[key];

      if (typeof val === 'undefined' || val === undefined) {
        delete search[key];
      } else if (val && typeof val === 'object' && val !== null) {
        try {
          search[key] = stringify(val);
        } catch (err) {// silent
        }
      }
    });
  }

  var searchStr = encode(search).toString();
  return searchStr ? "?" + searchStr : '';
}
export function parseSearch(searchStr) {
  if (searchStr.substring(0, 1) === '?') {
    searchStr = searchStr.substring(1);
  }

  var query = decode(searchStr); // Try to parse any query params that might be json

  for (var key in query) {
    var value = query[key];

    if (typeof value === 'string') {
      try {
        query[key] = parse(value);
      } catch (err) {//
      }
    }
  }

  return query;
}